export const SCOPES = [ 
    "User.Read", 
    // "Calendars.ReadWrite"
];